import { render, staticRenderFns } from "./CrisisSlot.vue?vue&type=template&id=1b931d21"
import script from "./CrisisSlot.vue?vue&type=script&lang=js"
export * from "./CrisisSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports